import { getIdToken } from "src/domains/shared/utils/amplifyCompat";
import { backendBaseUrl } from "src/domains/shared/api/calculation/backendBaseUrl";
import { RenameDrawingMeshParams } from "./drawingMesh.types";

/**
 * main-api는 "Bearer <token>" 형식 필요 — Amplify gateway(Bearer 없는 raw token)와 다르므로
 * API.post 대신 raw fetch + getIdToken() 으로 직접 호출한다 (postMeasure.ts 와 동일 패턴).
 * 대상 지정은 name(불변 식별자) — filename 을 재파생해 보내지 않는다.
 */
export async function renameDrawingMesh(
  projectId: number,
  params: RenameDrawingMeshParams
): Promise<unknown> {
  const token = await getIdToken();

  const res = await fetch(`${backendBaseUrl()}/projects/${projectId}/drawing-meshes`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify(params),
  });

  if (!res.ok) {
    throw Object.assign(
      new Error(`표시명 변경 실패 (${res.status})`),
      { status: res.status }
    );
  }

  const body = await res.json();
  // 응답 봉투 { status, data } 언랩
  return body.data ?? body;
}
